
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface CarouselControlProps {
  type: "previous" | "next";
  title: string;
  handleClick: () => void;
  disabled: boolean;
}

export const CarouselControl = ({
  type,
  title,
  handleClick,
  disabled,
}: CarouselControlProps) => {
  return (
    <Button
      variant="outline"
      size="icon"
      className={cn(
        "rounded-full bg-background/80 backdrop-blur-sm hover:bg-background/90 transition-all",
        disabled ? "opacity-50 cursor-not-allowed" : "opacity-100"
      )}
      title={title}
      onClick={handleClick}
      disabled={disabled}
    >
      {type === "previous" ? (
        <ChevronLeft className="h-4 w-4" />
      ) : (
        <ChevronRight className="h-4 w-4" />
      )}
      <span className="sr-only">{title}</span>
    </Button>
  );
};
